module.exports = __webpack_public_path__ + "static/media/ks.ed01edd8.svg";